import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m6 2.667 3.92 3.919a2 2 0 0 1 0 2.828L6 13.334"
	})
});
export default SvgChevronRight;
